module.exports = __webpack_public_path__ + "img/cover.92d4fc7a.jpeg";